import { render, staticRenderFns } from "./SoftSaleDialog.vue?vue&type=template&id=1a97f3cf"
import script from "./SoftSaleDialog.vue?vue&type=script&lang=js"
export * from "./SoftSaleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a97f3cf')) {
      api.createRecord('1a97f3cf', component.options)
    } else {
      api.reload('1a97f3cf', component.options)
    }
    module.hot.accept("./SoftSaleDialog.vue?vue&type=template&id=1a97f3cf", function () {
      api.rerender('1a97f3cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/SoftSaleDialog.vue"
export default component.exports